<ng-container *ngFor="let field of fields">

  <!-- List field -->
  <div class="form-group" *ngIf="field.model.input === 'list' && field.name !== 'type'">
    <label for="{{ field.name }}">{{ field.model.label }}</label>
    <t-select [items]="field.model.valuesList" [(item)]="field.value"></t-select>
    <!-- <span class="info info-right">{{ link.name }}.{{ field.name }}</span> -->
  </div>

  <!-- Text field -->
  <div class="form-group" *ngIf="field.model.input === 'text'">
    <label for="{{ field.name }}">{{ field.model.label }}</label>

    <input *ngIf="!field.control" id="{{ field.name }}" type="text" [(ngModel)]="field.value" />

    <input *ngIf="field.control" id="{{ field.name }}" type="text" [formControl]="field.control" maxlength="200" />
    <span *ngIf="field.control" class="info info-error" [hidden]="field.control.valid || field.control.pristine || !field.control.errors.required">Ce champ est requis</span>
    <!-- <span class="info info-right">{{ link.name }}.{{ field.name }}</span> -->
  </div>

  <!-- Boolean field -->
  <div class="form-group" *ngIf="field.model.input === 'boolean'">
    <label for="{{ field.name }}">{{ field.model.label }}</label>
    <t-option [options]="booleanOptions" [(value)]="field.value"></t-option>
    <!-- <span class="info info-right">{{ link.name }}.{{ field.name }}</span> -->
  </div>

</ng-container>